import React from 'react';
import PropTypes from 'prop-types';
import Yup from 'yup';
import { connect } from 'react-redux';
import { Field, Form, Formik } from 'formik';
import FormikDropzoneField from 'base/components/forms/formik/FormikDropzoneField';
import MainTitle from 'base/components/MainTitle';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import SubmitButton from 'base/components/forms/SubmitButton';
import importCsvTemplate from 'assets/files/user_import_template.csv';
import { importContacts } from '../../store/actions';

const ContactImportModal = ({
  name, //eslint-disable-line
  importContacts,
}) => (
  <>
    <MainTitle withSpaceBelow>Import users from CSV</MainTitle>

    <Formik
      initialValues={{
        csv: [],
      }}
      validationSchema={
            Yup.object().shape({
              csv: Yup.array()
                .required('Add at least one file'),
            })
          }
      render={({values, errors, isSubmitting, setFieldValue }) => ( // eslint-disable-line
        <Form>
          <div hidden={isSubmitting}>
            <Field
              type="text"
              name="csv"
              component={FormikDropzoneField}
              multiple={false}
              accept={['.csv']}
            />

            <FieldWrapper>
              <a href={importCsvTemplate} rel="noopener noreferrer" target="_blank">
                Download template file
              </a>
            </FieldWrapper>

            <SubmitButton type="submit" disabled={false}>
                Upload
            </SubmitButton>
          </div>
          <div hidden={!isSubmitting}>
              Uploading
          </div>
        </Form>
      )}
      onSubmit={(values) => {
        importContacts(values.csv[0].fileObject);
      }}
    />
  </>
);
ContactImportModal.propTypes = {
  name: PropTypes.string.isRequired,
  importContacts: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  importContacts,
};

export default connect(
  null,
  mapDispatchToProps,
)(ContactImportModal);
